import { complexTableQuery } from "../../common/utils/tableUtilities";

export const memberName = member => member?.preferredname ?? member?.firstname
export const memberFullname = member => `${memberName(member) ?? ''} ${member?.lastname ?? ''}`;
export const age = member => {
    if (member?.dob) {
        const birthDate = new Date(member.dob);
        const ageDiff = Date.now() - birthDate.getTime();
        const ageDate = new Date(ageDiff);
    
        return Math.abs(ageDate.getUTCFullYear() - 1970); // 1970 is the Unix epoch start
    }
    return 0;
}

export const memberSearch = (members, search = {}) => {
    let searchFields = Object.keys(search).filter(f => search[f] !== undefined && search[f] !== null);
    let results = Object.values(members).filter(m => {
        for (const field of searchFields) {
            // Note: Accreditation filtering requires the member accreditations which are handled by a different slice.
            //       Therefore that is handled as a separate filter outside this search.
            if (field === 'office') {
                if (search.office?.length > 0 && m.office.every(o => !search.office.includes(o))) {
                    return false;
                }
            } else if (field === 'minAge') {
                if (age(m) < search.minAge) {
                    return false;
                }
            } else if (field === 'maxAge') {
                if (age(m) > search.maxAge) {
                    return false;
                }
            } else if (field === 'status') {
                if (search.status && m.status != search.status) {
                    return false;
                }
            }
        }
        return true;
    })
    return complexTableQuery(results, search, {ignoreFields: ['accreditation', 'office', 'minAge', 'maxAge', 'status']});
}

export const isPrimary = (member, clientConfig) => member.status === clientConfig.memberStatus?.[0];